
import { CONFERENCE_LEFT } from '../base/conference';
import { ReducerRegistry } from '../base/redux';

import { SET_FOCUS_MODE_ENABLED } from './actionTypes';

const DEFAULT_STATE = {

    /**
     * Whether Focus Mode is currently on for the meeting.
     */
    enabled: false
};

/**
 * Reduces the redux actions of the Focus Mode feature.
 */
ReducerRegistry.register('features/focus-mode', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case SET_FOCUS_MODE_ENABLED:
        return {
            ...state,
            enabled: Boolean(action.enabled)
        };

    case CONFERENCE_LEFT:
        return DEFAULT_STATE;
    }

    return state;
});
